/* @flow */

import { useSelector, shallowEqual } from 'react-redux';

import { getAllLocations } from 'src/shared/domain/location/selector/locationSelectors';

import type { Location } from '@braindate/domain/lib/location/type';

export default function useLocations(): Array<Location> {
  // User schema doesn't depend on any other data for now, but the `getSelf`
  // selector returns a new user object whenever a part of the `entities` state
  // slice changes. Therefore it returns a new user object whenever the
  // entities are modified, even if the user data hasn't changed. To mitigate
  // that, we use a shallow comparison instead of the default strict comparison
  // of react-redux.
  return useSelector(getAllLocations, shallowEqual);
}
